import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M17.75 3h3.068l-6.702 7.658L22 21.079h-6.171l-4.837-6.319-5.528 6.32H2.39l7.167-8.193L2 3h6.328l4.367 5.776zm-1.078 16.245h1.7L7.401 4.738H5.577z"
    }, null, -1)
  ]))]))
}
export default { render: render }